import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { getStagingSlot } from "@/viewer-config";
import "./slate-header.scss";
export const SlateHeader = ({ children }) => {
    // Right-corner chrome: when targeting a staging API, a small
    // environment "lip" hangs from the top edge. Purely informational,
    // never interactive — the interactive bits (notifications bell,
    // settings gear, @username pill) live inside `AppNav`'s trailing
    // cluster so they can't overlap the lip and so the chrome stays
    // pointer-events: none.
    const stagingSlot = getStagingSlot();
    const className = stagingSlot
        ? "slate-header slate-header--staging"
        : "slate-header";
    return (_jsxs("div", { className: className, children: [children, stagingSlot ? (_jsx("div", { className: "slate-header__chrome", children: _jsx("span", { className: `slate-header__staging-lip slate-header__staging-lip--${stagingSlot}`, "aria-label": `Targeting ${stagingSlot} API`, title: `Targeting ${stagingSlot} API`, children: stagingSlot.toUpperCase() }) })) : undefined] }));
};
